import React from "react";
import { alertService } from "../common/alert.service";
import InputField from "../reusableComponents/InputField";
import SubmitButton from "../reusableComponents/SubmitButton";

class Forgot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: "",
      email: "",
      buttonDisabled: false,
      incorrectDetails: false,
      success: false,
    };
  }
  setInputValue(property, val) {
    val = val.trim();

    this.setState({
      [property]: val,
    });
  }
  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.doReset();
    }
  }
  handleKeyDownToken(e) {
    if (e.key === "Enter") {
      this.doTokenValidate();
    }
  }
  resetForm() {
    this.setState({
      buttonDisabled: false,
      incorrectDetails: true,
      success: false,
    });
  }
  async doTokenValidate() {
    if (!this.state.token) {
      this.setState({
        incorrectDetails: true,
      });
    } else {
      try {
        let res = await fetch("/validatetoken", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: this.state.token,
          }),
        });
        let result = await res.json();

        if (result && result.success) {
          this.props.history.push("/reset/" + result.token);
        } else if (result && result.success === false) {
          this.setState({
            incorrectDetails: true,
            token: "",
          });

          alertService.error(result.msg);
        }
      } catch (e) {
        console.log(e);
        this.setState({
          incorrectDetails: true,
          token: "",
        });
      }
    }
  }
  async doReset() {
    if (
      !this.state.email ||
      !this.state.email.includes("@") ||
      !this.state.email.includes(".")
    ) {
      this.resetForm();
      return;
    }
    this.setState({
      buttonDisabled: true,
    });

    try {
      let res = await fetch("/reset", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: this.state.email,
        }),
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({
          incorrectDetails: false,
          buttonDisabled: true,
          success: true,
        });
        this.props.history.push("/reset");
      } else if (result && result.success === false) {
        this.resetForm();
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
      this.resetForm();
    }
  }

  render() {
    return (
      <div className="app">
        <div className="container">
          <div className="resetForm">
            Reset Password
            <div className="instructions">
              A password reset token will be sent to your email.
            </div>
            <div className="errorText">
              {this.state.incorrectDetails
                ? "The email is invalid or does not exist in the system."
                : ""}
            </div>
            <InputField
              type="text"
              placeholder="Email"
              value={this.state.email ? this.state.email : ""}
              onChange={(val) => this.setInputValue("email", val)}
              onKeyDown={(e) => this.handleKeyDown(e)}
            />
            <SubmitButton
              text="Reset"
              disabled={this.state.buttonDisabled}
              onClick={() => {
                this.doReset();
                //return <Redirect to="/profile" />;
              }}
            />
            <div className="instructions">
              If you are still having trouble, please email it@renrns.com
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Forgot;
